
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOff as ObiOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-off.js';
 
 
 

 
 export const ObiOff = createComponent({
   react: React,
   tagName: 'obi-off',
   elementClass: ObiOffElement,
   events: {
     
   }
  });
 
 